module.exports = __webpack_public_path__ + "6faed83e3da022c3717dc450143a6099.pdf";